import { Button, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getPrizes } from "../../redux/slices/adminSlice";
import { getMe } from "../../redux/slices/userSlice";
import AddGiftModal from "./components/AddGiftModal";
import GiftsTable from "./components/GiftsTable";

const AdminGifts = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getMe()).then(() => dispatch(getPrizes()));
  }, [dispatch]);
  const [showAddNewGiftModal, setShowAddNewGiftModal] = useState(false);
  const onAddNewGift = () => {
    setShowAddNewGiftModal(true);
  };
  const handleOnCloseAddNewGiftModal = () => {
    setShowAddNewGiftModal(false);
  };
  const handleOnSuccessAddNewGift = () => {
    setShowAddNewGiftModal(false);
    dispatch(getMe()).then(() => dispatch(getPrizes()));
  };
  return (
    <Box padding="24px">
      <Stack direction="column">
        <Grid display="flex" justifyContent="center" padding="24px 0">
          <Typography variant="h5">{t("adminGifts.giftsOverview")}</Typography>
        </Grid>
        <Grid display="flex" direction="row" justifyContent="end">
          <Button onClick={onAddNewGift} variant="contained">
            {t("adminGifts.addNewGift")}
          </Button>
        </Grid>
        <GiftsTable />
      </Stack>
      {showAddNewGiftModal && (
        <AddGiftModal
          open={showAddNewGiftModal}
          onClose={handleOnCloseAddNewGiftModal}
          onSuccessAddNewGift={handleOnSuccessAddNewGift}
        />
      )}
    </Box>
  );
};
export default AdminGifts;
